import { ICompany } from '@company/company.structures';
import { IUser, IOTP, two_factor_otp } from './../../interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { environment } from '@environments/environment';

import { LoginType, Login } from './login.structure';
import { AuthService } from '@auth/auth.service';
import { AppService } from '@base/app.service';
import { CompanyService } from '@base/company/company.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { FormControlService } from '@base/form-controls.service';

import { trigger, transition, useAnimation } from '@angular/animations';
import { bounce, rubberBand, wobble, shake } from 'ng-animate';
import { ROLES, EMPTY, UNDEFINED } from '@base/utils';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
  animations: [
    trigger('bounce', [transition('* => *', useAnimation(shake))])
  ],
})

export class LoginComponent implements OnInit, OnDestroy {
  private loginAttempt: boolean;
  private subscriptions: Subscription[];

  username = new FormControl(null, [
    Validators.required, Validators.maxLength(100), Validators.email,
  ]);
  password = new FormControl(null, [
    Validators.required, Validators.minLength(4), Validators.maxLength(100),
  ]);
  otp = new FormControl(null, [

  ]);

  loginForm: FormGroup;

  login: LoginType;
  showSpinner: Boolean = false;
  companies: ICompany[];
  step = 1;
  company: ICompany;
  showHeader = false;
  showForgotPassword = true;

  bounce: any;

  // two factor authenticate
  required_two_factor = false;
  data_otp: any;
  data_login: any;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private mainService: AppService,
    public snackBar: MatSnackBar,
    private companyService: CompanyService,
    private formControlService: FormControlService,
  ) {
    this.companies = [];
    this.subscriptions = [];
    this.loginAttempt = false;
    this.loginForm = this.fb.group({
      username: this.username,
      password: this.password,
      // otp: this.otp
    });

    this.data_login = {};
    this.data_otp = {};

    // escuchar cuando se carguen las empresas al intentar LOGIN_AS...
    const companiesSubscription: Subscription = this.companyService.observeCompanies().subscribe(
      (companies: ICompany[]) => this.processCompanies(companies),
      (err: HttpErrorResponse) => {
        // const error: IErrorResponse = this.exceptionService.errorHandling(err);
        console.log(err.message);
      }
    );

    this.subscriptions = [...this.subscriptions, companiesSubscription,];
  }

  ngOnInit() {
    this.loginForm.patchValue({
      username: environment.testUser.email,
      password: environment.testUser.password,
    });

    // const token = localStorage.getItem('token');
    // const validToken = (token !== null && (typeof token !== 'undefined'));
    this.login = new Login();

    // if (validToken) {
    //   this.router.navigate(['home']);
    // } else {
    //   this.login = environment.testUser;
    // }
    this.login = environment.testUser;
  }

  ngOnDestroy() {
    this.showSpinner = false;
    this.subscriptions.map((subscription: Subscription) => subscription.unsubscribe());
  }

  private processCompanies(companies) {
    if (this.loginAttempt) {
      this.loginAttempt = false;
      const auxCompanies = [...companies];
      this.companies = auxCompanies.sort(this.dynamicSort('name'));
      localStorage.removeItem('token');
      this.showSpinner = false;
      this.step = (this.companies.length) ? 2 : 1;

      if (this.step === 1) {
        this.snackBar.open('La cuenta no tiene empresas habilitadas', 'info', {
          verticalPosition: 'top',
          horizontalPosition: 'right',
          duration: 4000,
        }).afterDismissed().subscribe(() => {
          this.username.enable();
          this.password.enable();
        });
      } else if ((this.step === 2) && this.companies.length === 1) {
        this.step = 1;  // para que no muestre el dropdown para seleccionar empresas
        this.company = this.companies[0];
        this.completeLogin();
      }
    }
  }

  handleFetchingError(err: HttpErrorResponse) {
    // let error: IErrorResponse;
    // error = this.exceptionService.errorHandling(err);
    console.log(err.message);
    this.openSnackBar('No se puede iniciar sesión', 'Login');
    this.router.navigate(['/']);
    localStorage.setItem('temp_url', this.router.url);
  }

  completeLoginOTP(user: IUser) {
    // En caso de ser un cliente... debe seleccionar la empresa para iniciar sesion
    if (user.role['code'] === ROLES.CUSTOMER) {
      this.showForgotPassword = false;
      this.login.id = user.id;
      this.login.token = user['token'];
      this.processCompanies(user.companies);

      // En caso de ser admin, lider o analista....
    } else {
      this.showSpinner = true;
      this.mainService.setToken(user['token']);
      this.router.navigate(['home']);
    }
    // si ocurrio un error...
  }

  loginUserOTP() {
    this.username.disable();
    this.password.disable();
    this.otp.disable();
    this.login = this.loginForm.value;
    this.showSpinner = true;
    const credentials = {
      email: this.login.username.toLowerCase(),
      otp_counter: (this.data_otp as two_factor_otp).otp_counter,
      verify_key: this.login.otp
    }

    // crear authService.otp para la validacion de codigo
    this.authService.otp(credentials).subscribe(
      (data: any) => {
        if (data['success']) {
          this.completeLoginOTP(this.data_login)
          this.data_login = null;
          this.data_otp = null;
        } else {
          this.otp.enable();
          this.openSnackBar(data['error_message'], 'login');
          this.showSpinner = false;
          this.showForgotPassword = true;
        }
      },
      (err) => {
        this.otp.enable();
        this.openSnackBar('Error interno en el servidor', 'login');
        this.showSpinner = false;
        this.showForgotPassword =  true;
      }
    )

  }

  loginUser() {
    this.username.disable();
    this.password.disable();
    this.login = this.loginForm.value;
    this.showSpinner = true;
    const credentials = {
      email: this.login.username.toLowerCase(),
      password: this.login.password,
    };

    this.authService.login(credentials).subscribe(
      (user: IUser) => {
        if (user['success']) {
          // valida si se requiere doble authentificacion
          if (user.two_factor_auth.require_two_factor) {
            // pasos a seguir si es neesario doble authenticacion
            delete this.login.password;
            this.loginAttempt = true;
            this.showSpinner = false;
            this.required_two_factor = true;
            this.data_login = user;
            this.data_otp = user.two_factor_auth;
            this.otp.setValidators([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(6)
            ])
            this.loginForm.addControl('otp', this.otp)
          } else {
            delete this.login.password;
            this.loginAttempt = true;
            this.mainService.setToken(user['token']);
            // En caso de ser un cliente... debe seleccionar la empresa para iniciar sesion
            if (user.role['code'] === ROLES.CUSTOMER) {
              this.showForgotPassword = false;
              this.login.id = user.id;
              this.login.token = user['token'];
              this.processCompanies(user.companies);

              // En caso de ser admin, lider o analista....
            } else {
              this.showSpinner = true;
              this.mainService.setToken(user['token']);
              this.router.navigate(['home']);
            }
            // si ocurrio un error...
          }
        } else {
          this.username.enable();
          this.password.enable();
          this.openSnackBar(user['error_message'], 'login');
          this.showSpinner = false;
          this.showForgotPassword = true;
        }
      },
      (err: HttpErrorResponse) => {
        this.showSpinner = false;
        this.username.enable();
        this.password.enable();
        this.handleFetchingError(err);
      },
    );
  }

  completeLogin() {
    localStorage.removeItem('token');
    const emptyCompany = (typeof this.company === UNDEFINED || this.company === EMPTY);
    const loginId = this.login['id'];
    const validUser = (typeof loginId !== UNDEFINED);

    if (!emptyCompany && validUser) {
      this.showSpinner = true;
      const companyId = this.company.hasOwnProperty('pk') ? this.company['pk'] : this.company.id;
      const info: object = { user_id: loginId, company_id: companyId };
      this.authService.registerSession(info).subscribe(
        (res) => {
          this.showSpinner = false;
          this.mainService.setToken(this.login.token);
          this.mainService.temp['company'] = this.company;
          localStorage.setItem('company', JSON.stringify(this.company));
          this.router.navigate(['home/panels/tableau']);
        },
        (err) => {
          this.showSpinner = false;
          console.log(err);
          this.step = 1;
          this.login = new Login();
          this.loginForm.patchValue({
            username: '',
            password: '',
          });
        }
      );
    } else if (emptyCompany && validUser) {
      this.showSpinner = false;
      this.openSnackBar('Seleccione la empresa para continuar', 'login');
    } else if (emptyCompany && !validUser) {
      this.openSnackBar('revisar la informacion suministrada');
    }
  }

  goRecover() {
    this.router.navigate(['recover']);
  }

  openSnackBar(message: string, action: string = '', duration: number = 4000): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: duration,
    });
  }

  selectCompany(event) {
    const company: ICompany = event.value;
    this.company = company;
  }

  getErrorMessage(control: FormControl) {
    const strError = this.formControlService.checkErrorInControl(control);
    return strError;
  }

  cancelLogin() {
    this.step = 1;
    this.companies = [];
    this.login = new Login();
    this.username.enable();
    this.password.enable();
    this.company = undefined;
    this.showForgotPassword = true;

    this.required_two_factor = false;
    this.loginForm.removeControl('otp')
  }

  private dynamicSort(property) {
    let sortOrder = 1;

    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      if (sortOrder === -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    };
  }
}
